import { AuthReducerAction } from "../models/auth-reducer-action.model";
import { AuthState } from "../models/auth-state.model";

export const authReducer: React.Reducer<AuthState, AuthReducerAction> = (prev, action) => {
    switch (action.type) {
        case 'SIGN_IN':
            return {
                isAuth: true,
                isLoading: false,
                name: action.name
            }
        case 'SIGN_OUT':
            return {
                isLoading: false,
                isAuth: false, 
            }
        case 'LOADING':
            return {
                ...prev,
                isLoading: true,
            }
        default:
            return prev;
    }
}